import { styled } from '@flex-design-system/stitches-react';
import { Legacy_Dropdown } from '../legacy-dropdown/Dropdown.mjs';
import { FOCUS_CLASS_NAME } from '../legacy-dropdown/styled.mjs';
import TextField from '../text-field/TextField.mjs';

const itemStyle = {
  "&[hidden]": {
    display: "none"
  },
  [`&.${FOCUS_CLASS_NAME}`]: {
    background: "$blackAlpha003"
  }
};
const MultiSelectOptionItem = styled(
  Legacy_Dropdown.CheckboxItem,
  itemStyle
);
const SingleSelectOptionItem = styled(
  Legacy_Dropdown.RadioItem,
  itemStyle
);
const StyledSearchInput = styled(TextField, {
  px: 6
});
const StyledAffixRoot = styled(Legacy_Dropdown.AffixRoot, {
  defaultVariants: {
    bordered: true
  },
  variants: {
    bordered: {
      true: {
        borderBottom: "1px solid rgba(36, 42, 48, 0.06)"
      },
      false: {
        borderBottom: "none"
      }
    }
  }
});

export { MultiSelectOptionItem, SingleSelectOptionItem, StyledAffixRoot, StyledSearchInput };
//# sourceMappingURL=styled.mjs.map
